import { render, staticRenderFns } from "./busquedaCedula.vue?vue&type=template&id=49969314&scoped=true"
import script from "./busquedaCedula.vue?vue&type=script&lang=js"
export * from "./busquedaCedula.vue?vue&type=script&lang=js"
import style0 from "./busquedaCedula.vue?vue&type=style&index=0&id=49969314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49969314",
  null
  
)

export default component.exports